export default __webpack_public_path__ + "static/media/fa.c09e3c69.svg";